
// Export validation utilities
export * from './validationRules';
export { ValidationMessages } from './validationMessages';
export { cleanScoreValue, calculatePercentage } from './examValidation';

// Basic validation functions for form inputs
export const isAlphabetsOnly = (value: string): boolean => {
  return /^[a-zA-Z\s\u00C0-\u017F]*$/.test(value); // Includes accented characters
};

export const isNumbersOnly = (value: string): boolean => {
  return /^[0-9]*$/.test(value);
};

export const isValidPhone = (value: string): boolean => {
  return /^[0-9+\-\s()]*$/.test(value);
};

export const isValidEmail = (value: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) && !/\s/.test(value);
};

// Debug helper function
export const logFunctionExecution = (functionName: string, ...args: any[]) => {
  console.log(`Executing ${functionName} with args:`, ...args);
};
